import { Constants } from './Constants';

import { Dispatcher } from './Dispatcher';

import { Action, check } from '../../../../pdc-platform/src/ts/actions/AppActions';
export { Action, check } from '../../../../pdc-platform/src/ts/actions/AppActions';

export module I {}

export class Actions {
    public loadFonts() {
        this.dispatcher.handleViewAction({
            actionType: Constants.LOAD_FONTS
        });
    }

    public loadFontsFinish() {
        this.dispatcher.handleViewAction({
            actionType: Constants.LOAD_FONTS_FINISH
        });
    }

    constructor(private dispatcher: Dispatcher) {}

    public static get(dispatcher: Dispatcher) {
        return new Actions(dispatcher);
    }
}
